<template>
  <div>
    <DashboardHeader title="Excel Uploads">
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-card
            class="mx-6 mt-4"
            shaped
            elevation="12"
            max-width="344"
            outlined
          >
            <h3 class="mx-5 mt-4">
              <v-icon>mdi-office</v-icon>Excel Templates
            </h3>
          </v-card>

          <v-card
            class="mx-6 mt-4"
            shaped
            elevation="12"
            max-width="344"
            outlined
          >
            <v-list-item three-line>
              <v-select
                @change="getSeletedDownloadUpload()"
                v-model="selectedUploadDownload"
                :items="uploadDownload"
                label="Select Download Or Upload"
              ></v-select>
            </v-list-item>
          </v-card>

          <v-card
            class="mx-6 mt-4"
            v-if="download"
            shaped
            elevation="12"
            max-width="344"
            outlined
          >
            <v-list-item three-line>
              <v-select
                @change="getSeletedFile()"
                v-model="selectedFile"
                :items="excelTemplates"
                label="Select Template File"
              ></v-select>
            </v-list-item>
            <h5 class="mx-6 mt-4" v-if="iframeSource">
              <v-btn text :color="getThemeColor" :href="iframeSource"
                >Download {{ getFilename }}</v-btn
              >
            </h5>
          </v-card>

          <v-card
            class="mx-6 mt-4"
            v-if="upload"
            shaped
            elevation="12"
            max-width="344"
            outlined
          >
            <v-list-item three-line class="mx-3">
              <v-select
                @change="getData()"
                :rules="rules"
                v-model="selectedFile"
                :items="excelTemplates"
                label="Select Template Type To Upload"
              ></v-select>
            </v-list-item>

            <!-- <XLSX @get-json="getExcelDataAsJson"></XLSX> -->
            <v-file-input
              :rules="rules"
              class="mx-3"
              label="Select File To Upload"
              @change="previewFile()"
            ></v-file-input>
            <v-row>
              <v-btn
                class="mx-auto mb-4"
                rounded
                @click="uploadFile()"
                :color="getThemeColor"
                dark
                >Upload File</v-btn
              >
            </v-row>
          </v-card>
        </v-flex>
        <v-flex xs12 md8>
          <v-snackbar v-model="snackBar" dark :color="getThemeColor">
            {{ snackText }}
            <v-btn color="pink" text @click="snackBar = false">Close</v-btn>
          </v-snackbar>

          <v-card
            class="mt-4 mb-2"
            v-if="iframeSource"
            shaped
            elevation="12"
            outlined
          >
            <VueDocPreview :value="iframeSource" type="office" />
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" width="600" persistent>
        <v-card>
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >Apply Fee ID to Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Students Selected:</v-card-title
          >
          <v-autocomplete
            label="Select Report Term"
            class="mx-10"
            :items="reportTerms"
            v-model="term"
          ></v-autocomplete>
          <DatePickerWithMenu
            @date-selected="getDSC"
            label="Date School Closes"
          ></DatePickerWithMenu>
          <DatePickerWithMenu
            @date-selected="getDSROP"
            label="Date School Re-Opens"
          ></DatePickerWithMenu>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="success" dark @click="applyExamDates()"
              >Submit</v-btn
            >
            <v-btn rounded color="primary" dark @click="closeDialog()"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </DashboardHeader>
  </div>
</template>

<script>
//import XLSX from "@/components/myLibrary/XLSX.vue";
import axios from "@/plugins/axios";
import helpers from "@/plugins/helpers";
import DashboardHeader from "@/components/DashboardHeader.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import VueDocPreview from "vue-doc-preview";

export default {
  components: { DashboardHeader, VueDocPreview, DatePickerWithMenu },
  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },

    getFilename() {
      if (this.selectedFile != null) {
        const fils = this.selectedFile.split("_");
        return fils[1] + " " + fils[2];
      } else {
        return null;
      }
    },
  },
  created() {
    this.$store.commit("setLoader", true);
    axios.getData("/auth/get-excel-templates").then((excelTemplates) => {
      this.$store.commit("setLoader", false);
      this.excelTemplates = [];
      excelTemplates.forEach((template) => {
        const fils = template.split("_");

        this.excelTemplates.push({
          text: fils[0] + " " + fils[1] + " " + fils[2],
          value: template,
        });
      });
    });
  },
  data: () => ({
    excelTemplates: [],
    iframeSource: null,
    selectedFile: null,
    fileToBeUploaded: null,
    fileToBeUploadedName: null,
    snackBar: false,
    snackText: null,
    dialog: false,
    rules: [(value) => !!value || "This Field is Required!"],
    dsc: new Date().toISOString().substr(0, 10),
    dsrop: new Date().toISOString().substr(0, 10),
    term: null,
    reportTerms: [
      { text: "Term 1", value: "Term 1" },
      { text: "Term 2", value: "Term 2" },
      { text: "Term 3", value: "Term 3" },
      { text: "Term 4", value: "Term 4" },
    ],
    itsExam: false,
    uploadDownload: [
      {
        text: "Download Excel Template",
        value: "download",
      },
      { text: "Upload Excel Template", value: "upload" },
    ],
    selectedUploadDownload: null,
    upload: false,
    download: false,
  }),
  methods: {
    getSeletedDownloadUpload() {
      if (this.selectedUploadDownload == "download") {
        this.download = true;
        this.upload = false;
      } else {
        this.download = false;
        this.upload = true;
      }
    },
    getSeletedFile() {
      this.iframeSource = helpers.getIframeSource(this.selectedFile);
      this.getApiUrl + "/excel_templates/" + this.selectedFile;
    },
    getExcelDataAsJson(jsonDataArray) {
      console.log(jsonDataArray);
    },
    getData() {
      if (this.selectedFile == "SASAMS_Exams_Schedule_Data_Upload.xls") {
        this.dialog = true;
      }
    },
    applyExamDates() {
      this.dialog = false;
    },
    closeDialog() {
      this.dialog = false;
    },
    getDSC(getDSC) {
      this.dsc = getDSC;
    },
    getDSROP(getDSROP) {
      this.dsrop = getDSROP;
    },
    previewFile() {
      if (
        event.target.files[0].name == "SASAMS_Exams_Schedule_Data_Upload.xls" &&
        (this.dsc == null || this.dsrop == null || this.term == null)
      ) {
        alert(
          "Term And Both Dates For School Closing And Re-Opening Are Required!"
        );
        this.fileToBeUploaded = null;
        location.reload();
        return false;
      } else {
        const file = event.target.files[0];
        this.fileToBeUploadedName = file.name;

        const fileReader = new FileReader();

        fileReader.addEventListener("load", () => {
          this.fileToBeUploaded = fileReader.result;
        });

        fileReader.readAsDataURL(file);
      }
    },
    uploadFile() {
      if (
        this.fileToBeUploaded == null ||
        this.fileToBeUploadedName == null ||
        this.selectedFile == null
      ) {
        alert("Specify the File Type and Then Select A File!");
        return false;
      } else {
        this.$store.commit("setLoader", true);
        let obj = null;
        if (this.dsc != null && this.dsrop != null && this.term != null) {
          obj = {
            file: this.fileToBeUploaded,
            name: this.fileToBeUploadedName,
            type: this.selectedFile,
            dsc: this.dsc,
            dsrop: this.dsrop,
            term: this.term,
          };
        } else {
          obj = {
            file: this.fileToBeUploaded,
            name: this.fileToBeUploadedName,
            type: this.selectedFile,
          };
        }
        axios
          .postDataWithToken(
            "/auth/upload-excel-template",
            obj,
            this.getAccessToken
          )
          .then((excelTemplates) => {
            this.$store.commit("setLoader", false);
            this.snackBar = true;
            this.snackText = "File Successfuly Uploaded";

            this.excelTemplates = [];
            excelTemplates.forEach((template) => {
              const fils = template.split("_");
              this.excelTemplates.push({
                text: fils[0] + " " + fils[1] + " " + fils[2],
                value: template,
              });
            });
          });
      }
    },
  },
};
</script>

<style></style>
